import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "search-tag-list" }
const _hoisted_2 = { class: "commonTextBodyDefault search-tag-list-text" }
const _hoisted_3 = { class: "search-tag-list-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchTagItem = _resolveComponent("SearchTagItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tags, (item) => {
        return (_openBlock(), _createBlock(_component_SearchTagItem, {
          class: "search-tag-list-item",
          key: item.id,
          label: _ctx.getTagName(item.name),
          alias: _ctx.alias,
          id: item.id,
          active: _ctx.isActive(item.id),
          onSelectTag: _ctx.selectTag
        }, null, 8, ["label", "alias", "id", "active", "onSelectTag"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}